import React from 'react';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import 'videojs-hls-quality-selector';
import 'videojs-contrib-quality-levels';
 

export const VideoJS = (props) => {
  const videoRef = React.useRef(null); 
  const playerRef = React.useRef(null);
  const { options, onReady } = props;
 
  React.useEffect(() => { 

    // Make sure Video.js player is only initialized once
    if (!playerRef.current) {
      // The Video.js player needs to be _inside_ the component el for React 18 Strict Mode. 
      const videoElement = document.createElement("video-js");

      videoElement.classList.add('vjs-big-play-centered');
      videoRef.current.appendChild(videoElement);
if(options){
      options['plugins'] = {
        /*  hotkeys: {
           volumeStep: 0.1,
           seekStep: 5,
           enableModifiersForNumbers: false
         } */
      }


      options['controls'] = true;
      options['responsive'] = true;
      options['TimeDisplay'] = true;
      options['userActions'] = { hotkeys: true };
      options['playbackRates'] = [0.5, 1, 1.25, 1.5, 2];
      options['fluid'] = true;

      options['breakpoints'] = {
        tiny: 300,
        xsmall: 400,
        small: 500,
        medium: 600,
        large: 700,
        xlarge: 800,
        huge: 900
      };

      
      /*      options['controlBar']={
             skipButtons: {
                 backward: 5,
               forward: 5
             }
           } ;
      */
          }
      const player = playerRef.current = videojs(videoElement, options, () => {
        // videojs.log('player is ready',options);
        console.log("player is ready");
 

        //player.qualityLevels = qualityLevels;
        // player.qualityLevels();
        // player.languageSwitch=languageSwitch;
// Plugin initialization
//player.current.qualityLevels();  

         
        /* player.languageSwitch({
          languages: [
            {
              name: 'English',
              sources: [
                {
                  src: 'http://bit.ly/2iJXRec',
                  type: 'video/mp4',
                  res: 'Medium'
                },
                {
                  src: 'http://bit.ly/2jxmfwI',
                  type: 'video/webm',
                  res: 'Medium'
                }
              ]
            },
            {
              name: 'Portuguese',
              sources: [
                {
                  src: 'http://bit.ly/2jVlmho',
                  type: 'video/mp4',
                  res: 'Medium'
                },
                {
                  src: 'http://bit.ly/2jVlTzx',
                  type: 'video/webm',
                  res: 'Medium'
                }
              ]
            }
          ],
          positionIndex: 15
        }) */



        onReady && onReady(player);
      
       

        let qualityLevels = player.qualityLevels();
        qualityLevels.selectedIndex_ = 0;
        qualityLevels.trigger({ type: 'change', selectedIndex: 0 });
        // console.log(qualityLevels) 


        /*   player.hlsQualitySelector = videojsqualityselector;
          player.hlsQualitySelector();  */

        function createQualityButton(qualityLevel, parent) {
          var button = document.createElement('button');
          if(button){

      
          var classes = button.classList;

          if (qualityLevel.enabled) {
            classes.add('enabled');
          } else {
            classes.add('disabled');
          }

          button.innerHTML = qualityLevel.width + 'x' + qualityLevel.height;
          button.id = 'quality-level-' + qualityLevel.id;

          button.onclick = function () {
            var old = qualityLevel.enabled;
            qualityLevel.enabled = !old;
            button.classList.toggle('enabled');
            button.classList.toggle('disabled');
          }
          if(parent){
          parent.appendChild(button);
        }
        }
        }
        function setup(player) {

          var qualityLevels = player.qualityLevels();
          var container = document.getElementById('quality-levels');

          qualityLevels.on('addqualitylevel', function (event) {
            createQualityButton(event.qualityLevel, container);
          });

          qualityLevels.on('change', function (event) {
            for (var i = 0; i < qualityLevels.length; i++) {
              var level = qualityLevels[i];
              var button = document.getElementById('quality-level-' + level.id);
              if(button){
               

                button.classList.remove('selected');
              }
              
            }

            var selected = qualityLevels[event.selectedIndex];
            var button = document.getElementById('quality-level-' + selected.id);
        
            if(button){
               

              button.classList.remove('selected');
            }

          })

        }


        setup(player)

      });

      // You could update an existing player in the `else` block here
      // on prop change, for example:
    } else {
      const player = playerRef.current;

      player.autoplay(options.autoplay);
      player.src(options.sources);


    }
  }, [options, videoRef]);

  // Dispose the Video.js player when the functional component unmounts
  React.useEffect(() => {
    const player = playerRef.current;

    return () => {
      if (player && !player.isDisposed()) {
        player.dispose();
        playerRef.current = null;
      }
    };
  }, [playerRef]);

  return (
    <div data-vjs-player>
    {/*   <div id="quality-levels">

      </div>  */}

      <div onContextMenu={e => e.preventDefault()} ref={videoRef} />
    </div>
  );
}

export default VideoJS;